module.exports = __webpack_public_path__ + "static/img/home_cajasecas.d889e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_cajasecas.png
// module id = 78
// module chunks = 0